import { Container, Typography, Box, Grid, useTheme } from '@mui/material';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

import ModernFooter from '../Components/ModernFooter';
import ModernCard from '../Components/ModernCard';

import {
  fadeInUp,
  staggerChildren,
  staggerItem,
} from '../styles/animations';

import ProjectsList from "../Data/Realisation.json";
import un_1 from "../Files/2sff_pv3x_211129.jpg";
import deux_2 from "../Files/18778.jpg";
import trois_3 from "../Files/night-modern-bridge.jpg";
import zero from '../african-american-worker-standing-uniform-wearing-safety-hat-factory.jpg'
import un from '../steel-bar-site-construction.jpg'
import deux from '../construction-engineer.jpg'


interface Props { }

function Projects(props: Props) {
    const { t, i18n } = useTranslation();
    const theme = useTheme();

    const projectImages = [
        un_1,
        deux_2,
        trois_3,
        zero,
        un,
        deux,
    ];

    // const projectIcons = [
    //     <Business />,
    //     <HomeWork />,
    //     <Apartment />,
    //     <Construction />,
    //     <Business />,
    //     <HomeWork />,
    // ];

    const firstBatch = ProjectsList.slice(0, 3);
    const secondBatch = ProjectsList.slice(3, 6);

    return (
        <Box sx={{ backgroundColor: theme.palette.background.default, minHeight: '100vh' }}>
            {/* Hero Section */}
            <Box 
                sx={{
                    background: 'linear-gradient(135deg, #003d7a 0%, #1e5ba8 50%, #ff6b35 100%)',
                    color: 'white',
                    py: 8,
                    position: 'relative',
                    overflow: 'hidden',
                }}
            >
                <Container maxWidth="lg">
                    <motion.div
                        variants={fadeInUp}
                        initial="initial"
                        whileInView="animate"
                        viewport={{ once: true, amount: 0.3 }}
                    >
                        <Typography
                            variant="h3"
                            component="h1"
                            align="center"
                            gutterBottom
                            sx={{ fontWeight: 700, mb: 3 }}
                        >
                            {t("contenu.texte75")}
                        </Typography>
                        <Typography
                            variant="h6"
                            align="center"
                            sx={{ opacity: 0.9, maxWidth: 800, mx: 'auto' }}
                        >
                            {t("contenu.texte76")}
                        </Typography>
                    </motion.div>
                </Container>
            </Box>

            {/* Projects Content */}
            <Container maxWidth="lg" sx={{ py: 8 }}>
                {/* First Batch */}
                <Box sx={{ mb: 8 }}>
                    <motion.div
                        variants={staggerChildren}
                        initial="initial"
                        whileInView="animate"
                        viewport={{ once: true, amount: 0.3 }}
                    >
                        <Grid container spacing={4}>
                            {firstBatch.map((project, index) => (
                                <Grid item xs={12} md={4} key={index}>
                                    <motion.div variants={staggerItem}>
                                        <ModernCard
                                            variant="project"
                                            image={projectImages[index]}
                                            title={t(project.title.split("|")[i18n.language.toLowerCase() === "fr" ? 0 : 1])}
                                            description={t(project.provider)}
                                            link="#"
                                            linkText="Voir les détails"
                                        />
                                    </motion.div>
                                </Grid>
                            ))}
                        </Grid>
                    </motion.div>
                </Box>

                {/* Second Batch */}
                <Box>
                    <motion.div
                        variants={staggerChildren}
                        initial="initial"
                        whileInView="animate"
                        viewport={{ once: true, amount: 0.3 }}
                    >
                        <Grid container spacing={4}>
                            {secondBatch.map((project, index) => (
                                <Grid item xs={12} md={4} key={index + 3}>
                                    <motion.div variants={staggerItem}>
                                        <ModernCard
                                            variant="project"
                                            image={projectImages[index + 3]}
                                            title={t(project.title.split("|")[i18n.language.toLowerCase() === "fr" ? 0 : 1])}
                                            description={t(project.provider.split("|")[i18n.language.toLowerCase() === "fr" ? 0 : 1])}
                                            link="#"
                                            linkText="Voir les détails"
                                        />
                                    </motion.div>
                                </Grid>
                            ))}
                        </Grid>
                    </motion.div>
                </Box>
            </Container>
            
            <ModernFooter />
        </Box>
    )
}

export default Projects
